import { useMutation } from "@tanstack/react-query";
import type { Conversation } from "@/types/conversationTypes";
import { conversationApi } from "@/api/conversationApi";

export const useGetConversationById = () => {
  return useMutation<Conversation, Error, string>({
    mutationFn: async (conversationId: string) => {
      const { data } = await conversationApi.getConversationById(conversationId);
      return data;
    },
  });
}
